export const client_id = process.env.REACT_APP_CLIENT_ID || "bMs1oY7IF1ZA3X4cXdsEKzrbjzlujxy2"
export const client_secret = process.env.REACT_APP_CLIENT_SECRET || "5etCwmcpPkt_oeYX_dEAJ41i5u3A"
